import type { ReactNode } from 'react';
import { Icon, type IconName } from './Icon';
import styles from './Alert.module.css';

export type AlertTone = 'info' | 'success' | 'danger';

const TONE_ICON: Record<AlertTone, { icon: IconName; color: string }> = {
  info: { icon: 'file-text', color: 'var(--color-primary-900)' },
  success: { icon: 'check', color: 'var(--color-success)' },
  danger: { icon: 'x', color: 'var(--color-danger)' },
};

export interface AlertProps {
  children: ReactNode;
  tone?: AlertTone;
  title?: string;
  className?: string;
}

/** Port of components/feedback/Alert.jsx. */
export function Alert({ children, tone = 'info', title, className }: AlertProps) {
  const { icon, color } = TONE_ICON[tone];
  return (
    <div
      className={[styles.alert, styles[tone], className].filter(Boolean).join(' ')}
      role={tone === 'danger' ? 'alert' : 'note'}
    >
      <Icon name={icon} size={18} color={color} className={styles.icon} />
      <div>
        {title ? <div className={styles.title}>{title}</div> : null}
        <div className={styles.body}>{children}</div>
      </div>
    </div>
  );
}
